import Marquee from "react-fast-marquee";

const items = [
    "IMPRESSÃO 3D",
    "PROTOTIPAGEM",
    "PEÇAS PERSONALIZADAS",
    "COSPLAY & COLECIONÁVEIS",
    "DESIGN SOB MEDIDA",
    "PEQUENAS SÉRIES",
];

export const MarqueeSection = () => (
    <section aria-hidden className="border-y border-forge-line bg-forge-ink py-8 md:py-12">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {items.map((it, i) => (
                <span key={i} className="mx-5 flex items-center gap-10 md:mx-8">
                    <span
                        className={`whitespace-nowrap font-display text-3xl font-bold uppercase tracking-tight md:text-5xl ${
                            i % 2 ? "text-outline" : "text-forge-yellow"
                        }`}
                    >
                        {it}
                    </span>
                    <span className="inline-block h-2 w-2 rotate-45 bg-forge-yellow/70" />
                </span>
            ))}
        </Marquee>
    </section>
);

export default MarqueeSection;
